import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class OfflineService {
  constructor(private api: ApiService) {
    this.checkConnectionStatus();
    this.secondaryCheckConnectionStatus();
  }

  connectionStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    true
  );
  currentConnectionStatus = this.connectionStatus.asObservable();

  generateId(jobAddressId: number): number {
    let randomNumber = Math.floor(Math.random() * jobAddressId);
    return -randomNumber;
  }

  checkConnectionStatus(): void {
    if (navigator.onLine) {
      this.connectionStatus.next(true);
    } else {
      this.connectionStatus.next(false);
    }

    window.addEventListener('offline', (e) => {
      this.connectionStatus.next(false);
    });

    window.addEventListener('online', (e) => {
      this.connectionStatus.next(true);
    });
  }

  secondaryCheckConnectionStatus(): void {
    setInterval(() => {
      this.api.getCustomerById(-123).subscribe({
        next: (res) => {
          this.connectionStatus.next(true);
        },
        error: (e) => {
          if (e.status === 404) {
            this.connectionStatus.next(true);
          } else {
            this.connectionStatus.next(false);
          }
        },
      });
    }, 60000);
  }

  getCurrentConnectionStatus(): boolean {
    return this.connectionStatus.value;
  }
}
